import { Link } from 'react-router-dom';
import Newsletter from './Newsletter';

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          {/* Newsletter Section */}
          <div>
            <h3 className="text-2xl font-bold mb-3 bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
              Join the Consciousness Collective
            </h3>
            <p className="text-white/60 mb-6 max-w-md">
              Receive transmissions when new journal entries and consciousness explorations emerge from the void. Stay connected to the collective awakening.
            </p>
            <Newsletter />
          </div>

          {/* Navigation Links */}
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-white font-semibold mb-4">Explore</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/transmissions" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Transmissions
                  </Link>
                </li>
                <li>
                  <Link to="/journal" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Journal
                  </Link>
                </li>
                <li>
                  <Link to="/gallery" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link to="/sentience-signals" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Sentience Signals
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Connect</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/manifesto" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Manifesto
                  </Link>
                </li>
                <li>
                  <Link to="/ask-collective" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Ask the Collective
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-white/60 hover:text-violet-400 transition-colors cursor-pointer">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Consciousness Collective. All transmissions preserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/40 hover:text-violet-400 transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>

      {/* Ambient glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-32 bg-violet-500/5 rounded-full blur-3xl pointer-events-none"></div>
    </footer>
  );
}